/*=============================================================================================
*
*      JS for carousel for the /centers/
*      Carousel is located in partials/carousels/centers-thumbnail-carousel.html
*      CSS and JS are loaded through respective Assets/main files
*       Author: ABLE Dev
==============================================================================================*/

import Swiper from 'swiper';

// core version + navigation, pagination modules:
import SwiperCore, { Autoplay, EffectFade } from 'swiper/core';

// configure Swiper to use modules
SwiperCore.use([ Autoplay, EffectFade ]);

export function worldclassSlider() {

const worldclassSlider = new Swiper('.world-class-slider', {
  slidesPerView: 1,
  effect: 'fade',
  speed: 900,
  allowTouchMove: true,
  fadeEffect: {
    crossFade: true,
  },
  centeredSlides: true,
  autoplay: {
    delay: 6000,
    disableOnInteraction: true,
  },
});

};